module.exports = __webpack_public_path__ + "img/icon1.08819dc8.png";